import React from 'react'

import { Modal } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useDispatch, useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'

import { toggleInbox } from '../../duck/actions'
import selectors from '../../duck/selectors'
import InboxContent from '../InboxContent'

const InboxModal: React.FC = () => {
  const isLargeScreen = useSelector(appSelectors.getIsDesktop)
  const isOpen = useSelector(selectors.getIsOpen)
  const dispatch = useDispatch()
  if (isLargeScreen) {
    return null
  }

  return (
    <Modal
      closeButtonText={getLabelFromStorage('general.close')}
      toggleModal={() => dispatch(toggleInbox())}
      isOpen={isOpen}
      title={getLabelFromStorage('omni.myaccount.inbox.modal.title')}
    >
      <InboxContent />
    </Modal>
  )
}

export default InboxModal
